"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.loggerMiddleware = void 0;

var _Telemetry = require("../telemetry/Telemetry");

var _loggingEvents = require("./loggingEvents");

var loggerMiddleware = function loggerMiddleware() {
  var telemetryProvider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Telemetry.telemetry;
  return function (_ref) {
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        var eventProperties = (0, _loggingEvents.createActionEvent)(action);
        var returnValue = next(action);
        (0, _loggingEvents.logAction)(action, telemetryProvider, eventProperties);
        return returnValue;
      };
    };
  };
};

exports.loggerMiddleware = loggerMiddleware;